import { IApplicationState } from '../../types/redux';
import { EFilterJsonQueryActionType, TFilterJsonQueryActions } from '../../actions/filterJsonQuery/types';

export function filterJsonQueryReducer(
  state: IApplicationState['filterJsonQuery'] = {},
  action: TFilterJsonQueryActions,
): IApplicationState['filterJsonQuery'] {
  switch (action.type) {
    case EFilterJsonQueryActionType.SetJsonQuery:
      return action.payload;
    default:
      return state;
  }
}
